"use client";

import React, { useState, useEffect } from "react";
import {
  IconButton,
  Typography,
  Box,
  Tooltip,
  Avatar,
  Menu,
  MenuItem,
  ListItemIcon,
  Divider,
} from "@mui/material";
import { Link } from "react-router-dom";
import Cookies from "js-cookie";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import LogoutIcon from "@mui/icons-material/Logout";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";

const Profile = () => {
  const [anchorEl, setAnchorEl] = useState(null);
  const [user, setUser] = useState(null);
  const open = Boolean(anchorEl);

  useEffect(() => {
    // read user info saved in cookies at login
    const userCookie = localStorage.getItem('neuro_patientportal_userName')
    if (userCookie) {
      setUser(userCookie);
    }

  }, []);

  const handleClick = (event) => setAnchorEl(event.currentTarget);
  const handleClose = () => setAnchorEl(null);

  const username = user
  const userType = user?.type || "Patient";

  return (
    <>
      <Tooltip title="Account">
        <IconButton
          onClick={handleClick}
          size="small"
          sx={{ p: 0, borderRadius: "5px" }}
          aria-controls={open ? "account-menu" : undefined}
          aria-haspopup="true"
          aria-expanded={open ? "true" : undefined}
        >
          <Avatar
            src="/images/patient-avatar.jpg"
            alt={username}
            sx={{
              width: { xs: 45, sm: 55 },
              height: { xs: 45, sm: 55 },
              mx: "auto",
              border: "3px solid #C2CDFF",
              boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
            }}
          />
          <Box
            sx={{
              textAlign: "left",
              mx: 1,
              display: { xs: "none", sm: "block" },
            }}
          >
            <Typography
              variant="body2"
              sx={{ fontWeight: 600, color: "#111", lineHeight: 1 }}
            >
              {username}
            </Typography>
            <Typography variant="caption" color="text.secondary">
              {userType}
            </Typography>
          </Box>
          <KeyboardArrowDownIcon sx={{ fontSize: 16 }} />
        </IconButton>
      </Tooltip>

      <Menu
        anchorEl={anchorEl}
        id="account-menu"
        open={open}
        onClose={handleClose}
        onClick={handleClose}
        PaperProps={{
          elevation: 0,
          sx: {
            borderRadius: "8px",
            boxShadow: "0 4px 30px rgba(0,0,0,.1)",
            mt: 1.5,
            overflow: "visible",
            "& .MuiAvatar-root": { width: 32, height: 32, ml: -0.5, mr: 1 },
            "&:before": {
              content: '""',
              display: "block",
              position: "absolute",
              top: 0,
              right: 14,
              width: 10,
              height: 10,
              bgcolor: "background.paper",
              transform: "translateY(-50%) rotate(45deg)",
              zIndex: 0,
            },
          },
        }}
        transformOrigin={{ horizontal: "right", vertical: "top" }}
        anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
      >
        {/* User summary */}
        <MenuItem sx={{ p: "10px 20px" }}>
          <Avatar
            src="/images/patient-avatar.jpg"
            alt={username}
            sx={{
              width: { xs: 45, sm: 55 },
              height: { xs: 45, sm: 55 },
              mx: "auto",
              border: "3px solid #C2CDFF",
              boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
            }}
          />
          <Box>
            <Typography
              variant="subtitle2"
              sx={{ fontWeight: 600, color: "#111" }}
            >
              {username}
            </Typography>
            <Typography variant="caption" color="text.secondary">
              {userType}
            </Typography>
          </Box>
        </MenuItem>

        <Divider sx={{ borderColor: "#F0F1F3", my: 0.5 }} />

        {/* My Profile */}
        <MenuItem sx={{ p: "8px 20px" }}>
          <Link
            to="/dashboard/patient-profile"
            style={{
              display: "flex",
              alignItems: "center",
              textDecoration: "none",
              color: "#111",
            }}
          >
            <ListItemIcon sx={{ mr: -1 }}>
              <AccountCircleIcon fontSize="small" />
            </ListItemIcon>
            <Typography variant="body2" sx={{ fontWeight: 500 }}>
              My Profile
            </Typography>
          </Link>
        </MenuItem>

        {/* Logout */}
        <MenuItem sx={{ p: "8px 20px" }}>
          <a
            href="/authentication/logout/"
            style={{
              display: "flex",
              alignItems: "center",
              textDecoration: "none",
              color: "#111",
              width: "100%",
            }}
          >
            <ListItemIcon sx={{ mr: -1 }}>
              <LogoutIcon fontSize="small" color="error" />
            </ListItemIcon>
            <Typography
              variant="body2"
              sx={{ fontWeight: 500, color: "error.main" }}
            >
              Logout
            </Typography>
          </a>
        </MenuItem>
      </Menu>
    </>
  );
};

export default Profile;